// extracted by mini-css-extract-plugin
export var section = "styles-module--section--Kmh9-";
export var box = "styles-module--box--1ghHy";
export var title = "styles-module--title--2YhEo";
export var button = "styles-module--button--2Kp6W";